import React from 'react';
import { useState } from 'react';
import { useEffect } from 'react';
import lock from '../../assets/img/lock.svg';
import carbrand from '../../assets/img/carshonda.jpg';
import appstore from '../../assets/img/appstore.png';
import googleplay from '../../assets/img/googleplay.png';
import speedometer from '../../assets/img/speedometer.svg';
import gasolinePump from '../../assets/img/gasoline-pump.svg';
import car from '../../assets/img/car.svg';
import book from '../../assets/img/book.svg';
import barcode from '../../assets/img/barcode.svg';
import Barcode from "react-barcode";
import tag from '../../assets/img/tag.svg';
import Path from '../../assets/img/Path.svg';
import transmission from '../../assets/img/manual-transmission.svg';
import drivetrain from '../../assets/img/drivetrain.svg';
import cars01 from '../../assets/img/cars01.png';
import carshonda from '../../assets/img/carshonda.jpg';
import persent from '../../assets/img/persent.svg';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import API from "../../Services/BaseService";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import Loading from "../../Component/Loading/Loading";
import UrCarAction from '../UrCar/UrCarAction';
import PageNotFound from '../FallBackUI/PageNotFound';
// import wsBaseURL from '../../Services/Constant';
// import { w3cwebsocket as W3CWebSocket } from "websocket";
import miles from '../../assets/img/miles.jpg';


// const ws=new WebSocket(wsBaseURL);
// const contentDefaultMessage = "Start writing your document here";

const EditDetails = (props) => {
	const { backURL, id } = props.location.state;
	const history = useHistory();
	const [loading, setLoading] = useState(true);
	const [carDetail, setCarDetail] = useState([]);
	const [proxyBidList, setProxyBidList] = useState([]);
	const [lrgImg, setLrgImg] = useState("");
	const [distance, setDistance] = useState("");
	const [copied, setCopied] = useState(false);
	const [bidFlag, setBidFlag] = useState(false);
	const [changesFlag, setChangesFlag] = useState("no");

	// const { id } = useParams();
	// const [sellitNowError, setSellitNowError] = useState("");
	const [isShown, setIsShown] = useState(false);
	const [selectedBid, setSelectedBid] = useState("");
	const [bidType, setbidType] = useState("");

	const [copySuccess, setCopySuccess] = useState('');
	const [selectDays, setSelectDays] = useState("");
	const [message, setMessage] = useState(null);
	const [maxPrice, setMaxPrice] = useState("");
	const [announcement, setAnnouncement] = useState(null);
	const [sellAmount, setSellAmount] = useState(null);
	console.log(sellAmount,"sellAmount======");
	const [sellItError, setSellItError] = useState("");
	const [messageError, setMessageError] = useState("");
	const [days, setDays] = useState([1, 2, 3, 4, 5]);
	const sellerData = useSelector(state => state.LoginReducer.payload);
	const [errors, setErrors] = useState("");
	const [errorFlag, setErrorFlag] = useState(false);
	const dealerData = useSelector(state => state.DealerReducer.payload);
	const [lrgVideo, setLrgVideo] = useState("");
	const [isVideoFlag, setIsVideoFlag] = useState(false);
	const [SalesIdError, SetSalesIdError] = useState("");
	const [changesArray, setChangesArray] = useState([]);
	console.log("changesArray", changesArray);

	console.log(bidFlag, "bidFlag");

	const dispatch = useDispatch();

	const redirectpage = (pathid, seller_data) => {
		dispatch(UrCarAction.sellerid(seller_data))
		history.push({
			pathname: "/cardetails",
			state: { backURL, id: pathid, sellerDealerId: seller_data.seller_dealer_id },
		});
	}

	function EditDetailList(data) {

		const request = {
			car_id: id,
			seller_dealer_id: data == undefined || data === null ? sellerData.seller_dealer_id : data.seller_dealer_id,
			seller_id: sellerData.seller_id,
			seller_token: sellerData.seller_token,

		}
		API.post('carDetails/condition', request).then(res => {
			if (res.data.success === true) {
				let merged = []
				for (let i = 0; i < res.data.data.length; i++) {
					merged.push({
						...res.data.data[i], ...(res.data.data1.find((item) => item.car_id === res.data.data[i].car_id))
					})
				}
				setCarDetail(merged)
				setSelectDays(res.data.data[0].days);
				setbidType(res.data.data[0].sales_type)
				setSelectedBid(res.data.data[0].sales_type_id)
				setDistance(res.data.distance);
				setLrgImg(res.data.data[0].image);
				setLrgVideo(res.data.data[0]?.image);
				setIsVideoFlag(false)
				setMaxPrice(res.data.data[0].max_price);
				setLoading(false);
			}
			else {
				setErrors(res.data.error)
				setErrorFlag(true)
			}

		})
			.catch(function (error) {
				if (error.response) {
					setErrors(error.response.data.error)
					setErrorFlag(true)
					setLoading(false);
				}
			});
	}

	const config = {
		background: "#f5f5f5",
		displayValue: false,
		marginTop: "20px",
		marginBottom: "20px",
		fontOptions: "italic",
		width: 2,
		heigth: 5
	};

	function ProxyBid() {
		const request = {
			car_id: id,
			seller_id: sellerData.seller_id,
			seller_token: sellerData.seller_token,

		}
		API.post('proxybidDetails/condition', request).then(res => {

			console.log("proxybidresponse", res.data.data);
			if (res.data.success === true) {
				setProxyBidList(res.data.data);

			}
			else {
				setErrors(res.data.error)
				setErrorFlag(true)
			}

		})
			.catch(function (error) {
				if (error.response) {
					setErrors(error.response.data.error)
					setErrorFlag(true)
				}
			});
	}

	// 	const handleSave = (high_bid,max_price,days,dealer_message) => {

	// 		setSellItError("") 
	// 	setMessageError("")
	// 	if(message && message.length > 200){
	// 		setMessageError("Message must not exceed 200 characters")
	// 		return;
	// 	} 


	// 	// if( Number(sellAmount) && Number(maxPrice) << Number(high_bid)){
	// 	// 	setSellItError("Sell it Now must be greater than high bid");
	// 	// 	return;
	// 	// }

	// 	if (high_bid !== null || high_bid !== "" || high_bid !== undefined){
	// 	if( Number(sellAmount) < Number(high_bid)){
	// 		setSellItError("Sell it Now must be greater than high bid");
	// 		return;
	// 	}

	// 	else if (sellAmount%50 !== 0){
	// 		setSellItError("Sell it Now accept only multiples of 50")
	// 		return;
	// 	}
	// } 
	// else {

	// 	if (sellAmount%50 !== 0){
	// 		setSellItError("Sell it Now accept only multiples of 50")
	// 		return;
	// 	}
	// }

	// 	  ws.onopen = () => {
	// 		  console.log('WebSocket ws Connected');
	// 	  };

	// 	  console.log('wsCall===========>', );

	// 	  ws.send(JSON.stringify({
	// 		car_id:id,
	// 		days:!selectDays ? "" : selectDays,
	// 		dealer_message:!message ? dealer_message : message,
	// 		max_price:!sellAmount ? max_price : sellAmount  ,model:'editDealer'}))


	// 	  ws.onmessage = (message) => {
	// 		  console.log("check the message ===",message)
	// 		  const dataFromServer = JSON.parse(message.data)
	// 		  console.log("check the  data FromServer in edit details pages", dataFromServer)
	// 		  if(dataFromServer[1] == "editDealer" && dataFromServer[2]?.success) {

	// 			redirectpage(carDetail[0].car_id,carDetail[0])
	// 		  	console.log("check the redirection",carDetail[0].car_id)

	// 		} 
	// 	  }

	// 	}

	const handleSave = (high_bid, min_price, max_price, days, dealer_message) => {

		setSellItError("")
		setMessageError("")
		// if (message && message.length > 200) {
		// 	setMessageError("Message must not exceed 200 characters")
		// 	return;
		// }

		// if (!sellAmount) {
		// 	setSellItError("Sell it Now  is required");
		// 	return;
		// }
		// if (Number(sellAmount) < Number(min_price)) {
		// 	setSellItError("Sell it Now must be greater than minimum bid");
		// 	return;
		// }
		if (Number(sellAmount)) {
		if (Number(sellAmount) < Number(high_bid)) {
			setSellItError("Sell it Now must be greater than high bid");
			return;
		}
	}

		/*  if( Number(sellAmount) && Number(maxPrice) << Number(high_bid)){
		 	setSellItError("Sell it Now must be greater than high bid");
		 	return;
		 }
		 if (!sellAmount) {
		 	setSellItError("Sell it Now  is required")
		 	return;
		   } */

		/*  if (high_bid !== null || high_bid !== "" || high_bid !== undefined) { */
		 	/* if (Number(sellAmount) < Number(high_bid)) {
		 		setSellItError("Sell it Now must be greater than high bid");
		 		return;
		 	} */

		 /* 	else if (sellAmount % 50 !== 0) {
		 		setSellItError("Sell it Now accept only multiples of 50")
		 		return;
		 	}
		 }
		 else {

		 	if (sellAmount % 50 !== 0) {
		 		setSellItError("Sell it Now accept only multiples of 50")
		 		return;
		 	}
		 }
 */
		const request = {
			car_id: id,
			days: selectDays,
			sales_type_id: selectedBid,
			dealer_message: !message ? carDetail[0].dealer_message : message,
			max_price: !sellAmount ? max_price : sellAmount,
			seller_id: sellerData.seller_id,
			seller_token: sellerData.seller_token,
			valuechanges: changesFlag,
			historylist: changesArray

		}
		API.post('editDealer/update', request).then(res => {
			console.log("response", res.data.data);
			if (res.data.success === true) {
				redirectpage(carDetail[0].car_id, carDetail[0])

			}
			else {
				setErrors(res.data.error)
				setErrorFlag(true)
			}

		})
			.catch(function (error) {
				if (error.response) {
					setErrors(error.response.data.error)
					setErrorFlag(true)
				}
			});
	}

	function copytoclipboard(e) {
		document.execCommand('copy');
		e.target.focus();
		setCopySuccess('Copied!');
	};

	function img1Click(img) {
		loadLrgImg(img.target.src);
		setIsVideoFlag(false)

	}
	function img2Click(img) {
		console.log("values passed", img);
		console.log("Imgfile", img.target.src);
		loadLrgImg(img.target.src);
		setIsVideoFlag(false)

	}
	function img3Click(img) {
		loadLrgImg(img.target.src);
		setIsVideoFlag(false)

	}
	function img4Click(img) {
		loadLrgImg(img.target.src);
		setIsVideoFlag(false)

	}
	function loadLrgImg(img) {
		setLrgImg(img);
	}
	function video1Click(video) {
		largeVideoLoad(video)
		setIsVideoFlag(true)
	}
	function video2Click(video) {
		largeVideoLoad(video);
		setIsVideoFlag(true)
	}

	function video3Click(video) {
		largeVideoLoad(video);
		setIsVideoFlag(true)
	}

	function video4Click(video) {
		largeVideoLoad(video);
		setIsVideoFlag(true)
	}

	function largeVideoLoad(video) {
		setLrgVideo(video);
	}
	const numberPattern = (e) => {
		const value = e.target.value.replace(/\D/g, "");
		setSellAmount(value);
	};

	// useEffect(() => {
	// 	if (bidFlag === false) {
	// 		let intervalId;

	// 		intervalId = setInterval(() => {
	// 			EditDetailList(dealerData);
	// 			ProxyBid();
	// 		}, 10000)
	// 		return () => clearInterval(intervalId);

	// 	} else {
	// 		let intervalId;

	// 		intervalId = setInterval(() => {
	// 			ProxyBid();
	// 		}, 10000)
	// 		return () => clearInterval(intervalId);

	// 	}

	// }, [])


	useEffect(() => {
		EditDetailList(dealerData);
		ProxyBid();
	}, [])
	const handleDays = (e) => {
		setChangesFlag("yes")
		const newValue = e.target.value;
		const oldvalue = carDetail[0].days == null ? "" : carDetail[0].days;
		setSelectDays(newValue);
		const existingChangeIndex = changesArray.findIndex(change => change.name === 'Days');
		if (existingChangeIndex !== -1) {
			const updatedChangesArray = [...changesArray];
			updatedChangesArray[existingChangeIndex] = { oldvalue: oldvalue, newvalue: newValue, name: 'Days' };
			setChangesArray(updatedChangesArray);
		} else {
			const change = { oldvalue: oldvalue, newvalue: newValue, name: 'Days' };
			setChangesArray([...changesArray, change]);
		}
	}
	const handleBidtype = (e) => {
		setChangesFlag("yes")
		const newValue = e.target.value == 1 ? "Sealed Bid Sales"
			: e.target.value == 2 ? "Make Bid" :
				e.target.value == 3 ? "Auction" : "";
		const oldvalue = carDetail[0].sales_type == null ? "" : carDetail[0].sales_type;
		setSelectedBid(e.target.value);
		ProxyBid()
		setBidFlag(true)
		const existingChangeIndex = changesArray.findIndex(change => change.name === 'Bidtype');
		if (existingChangeIndex !== -1) {
			const updatedChangesArray = [...changesArray];
			updatedChangesArray[existingChangeIndex] = { oldvalue: oldvalue, newvalue: newValue, name: 'Bidtype' };
			setChangesArray(updatedChangesArray);
		} else {
			const change = { oldvalue: oldvalue, newvalue: newValue, name: 'Bidtype' };
			setChangesArray([...changesArray, change]);
		}
	}
	const handlePrice = (e) => {
		setChangesFlag("yes")
		const oldvalue = carDetail[0].max_price == null ? "" : carDetail[0].max_price;
		const newValue = e.target.value.replace(/\D/g, "");
		setSellAmount(newValue);
		const existingChangeIndex = changesArray.findIndex(change => change.name === 'Price');
		if (existingChangeIndex !== -1) {
			const updatedChangesArray = [...changesArray];
			updatedChangesArray[existingChangeIndex] = { oldvalue: oldvalue, newvalue: newValue, name: 'Price' };
			setChangesArray(updatedChangesArray);
		} else {
			const change = { oldvalue: oldvalue, newvalue: newValue, name: 'Price' };
			setChangesArray([...changesArray, change]);
		}
	}
	const handleMessage = (e) => {
		setChangesFlag("yes")
		const newValue = e.target.value;

		const oldvalue = carDetail[0].dealer_message == null || carDetail[0].dealer_message == undefined ? "" : carDetail[0].dealer_message;
		setMessage(newValue);
		setBidFlag(true)
		const existingChangeIndex = changesArray.findIndex(change => change.name === 'Message From The Dealer');
		if (existingChangeIndex !== -1) {
			const updatedChangesArray = [...changesArray];
			updatedChangesArray[existingChangeIndex] = { oldvalue: oldvalue, newvalue: newValue, name: 'Message From The Dealer' };
			setChangesArray(updatedChangesArray);
		} else {
			const change = { oldvalue: oldvalue, newvalue: newValue, name: 'Message From The Dealer' };
			setChangesArray([...changesArray, change]);
		}
	}
	return (

		<main id="main" class="inner-page">
			{loading ? <Loading /> :
				<div id="products-details" class="products-details">

					{errorFlag === true ? <PageNotFound error={errors} /> :
						<div class="container-fluid inner-page-space">
							<div class="back-btn">
								<a class="back-btn-primary" onClick={() => { redirectpage(carDetail[0].car_id, carDetail[0]) }}><i class="bx bx-chevron-left"></i> Back</a>
							</div>
							<div class="row">
								{carDetail.length > 0 &&
									<div class="col-lg-6">
										<div class="vehicle-detail-banner banner-content clearfix">
											<div class="banner-slider">
												<div class="slider slider-for">
													<div class="slider-banner-image">
														{isVideoFlag === false ?
															<img src={lrgImg} alt="no image" width={"390px"} height={"470px"} /> :
															<video key={lrgVideo} autobuffer autoPlay controls width={"390px"} height={"470px"}>
																<source className="card-img-top" src={lrgVideo} type="video/mp4" />
															</video>}
													</div>
												</div>
												<div class="slider slider-nav thumb-image">
													{carDetail.length > 1 ?
														<div class="thumbnail-image">
															<div class="thumbImg">
																{carDetail[1]?.format == "video" ?
																	<video autobuffer controls width="100%" height="100%" onClick={() => { video1Click(carDetail[1]?.carimage) }}>
																		<source
																			id="mp4"
																			className="card-img-top"
																			src={carDetail[1]?.carimage}
																			type="video/mp4"
																		></source>
																	</video> :

																	<img src={carDetail[1]?.carimage} alt="" onClick={img1Click} width="100%" height="100%" />}
															</div>
														</div> : ""}
													{carDetail.length > 2 ?
														<div class="thumbnail-image">
															<div class="thumbImg">
																{carDetail[2]?.format == "video" ?
																	<video autobuffer controls width="100%" height="100%" onClick={() => { video2Click(carDetail[2]?.carimage) }}>
																		<source
																			id="mp4"
																			className="card-img-top"
																			src={carDetail[2]?.carimage}
																			type="video/mp4"
																		></source>
																	</video> :

																	<img src={carDetail[2]?.carimage} alt="" onClick={img2Click} width="100%" height="100%" />}
															</div>
														</div> : ""}
													{carDetail.length > 3 ?
														<div class="thumbnail-image">
															<div class="thumbImg">
																{carDetail[3]?.format == "video" ?
																	<video autobuffer controls width="100%" height="100%" onClick={() => { video3Click(carDetail[3]?.carimage) }}>
																		<source
																			id="mp4"
																			className="card-img-top"
																			src={carDetail[3]?.carimage}
																			type="video/mp4"
																		></source>
																	</video> :

																	<img src={carDetail[3]?.carimage} alt="" onClick={img3Click} width="100%" height="100%" />}
															</div>
														</div> : ""}
													{carDetail.length > 4 ?
														<div class="thumbnail-image">
															<div class="thumbImg">
																{carDetail[4]?.format == "video" ?
																	<video autobuffer controls width="100%" height="100%" onClick={() => { video4Click(carDetail[4]?.carimage) }}>
																		<source
																			id="mp4"
																			className="card-img-top"
																			src={carDetail[4]?.carimage}
																			type="video/mp4"
																		></source>
																	</video> :

																	<img src={carDetail[4]?.carimage} alt="" onClick={img4Click} width="100%" height="100%" />}
															</div>
														</div> : ""}


												</div>
											</div>
										</div>
									</div>}

								{carDetail.length > 0 &&
									<div class="col-lg-6">
										<div class="product-dtl">
											<div class="cars-detail-inside">
												<div class="cars-detail-views">
													<p class="car-btns"><span className="greytext">Inventory # : </span> {carDetail[0].car_id}</p>
												</div>
											</div>
											<div class="product-info">
												<div class="product-name">
													<p>
														{carDetail[0].year} {carDetail[0].make} {carDetail[0].model}</p>
												</div>
												<div class="km-petrol">
													<p class="details"><img src={speedometer} alt="" /><span>{carDetail[0].mileage} {carDetail[0]?.mileage_type}</span></p>&nbsp;&nbsp;&nbsp;&nbsp;
													{carDetail[0].fuel_type == "null" || carDetail[0].fuel_type == "" || carDetail[0].fuel_type == null || carDetail[0].fuel_type == undefined || carDetail[0].fuel_type == "undefined" ? "" :
														<p class="details"><img src={gasolinePump} alt="" /><span>{carDetail[0].fuel_type}</span></p>}
													<a class="labeltype"><span>{carDetail[0].label_type === "Sealed Bid Sales" ? carDetail[0].label_type.substr(0, 10) : carDetail[0].label_type}</span></a>
												</div>

												<p class="odometer"><span className="label">Is Odometer working</span> : {carDetail[0].odometer}</p>



												<div class="row vinqr">
													<div class="col-md-12 carpoints">
														<div className="label">Vin # : </div>
														<div class="carpoint">
															<img src={car} alt="" />
															<span>{carDetail[0].vin_no}</span>
															<CopyToClipboard text={carDetail[0].vin_no} onCopy={() => setCopied(true)}>
																<span title="Copy" onClick={copytoclipboard} className="copyImg"><i class="icofont-copy"></i></span>
															</CopyToClipboard>
															<img src={barcode} alt="" onMouseEnter={() => setIsShown(true)} onMouseLeave={() => setIsShown(false)} />
														</div>

													</div>
													{isShown && (
														<div>
															<Barcode value={carDetail[0].vin_no} {...config} />
														</div>
													)}
												</div>

												<div class="">
													<div class="titlestatus">
														<h3 className="label">Title status :<span className='tit-sold'> {/* {item.title}</span> */}
															<div className={`${carDetail[0]?.title === "Title" ? "title-cart" : carDetail[0]?.title === "Title Attached" ? "titleattached-cart" : carDetail[0]?.title === "Bill of sale only" ? "billofsale-cart" : ""}`}>{carDetail[0]?.title}</div></span></h3>

													</div>
												</div>

												<div class="editDays">
													{carDetail[0].days === 1 || carDetail[0].days == null || carDetail[0].days == "" ? <p class="remaindays">{carDetail[0].days} day still to go</p> :
														<p class="remaindays">{carDetail[0].days} days still to go</p>}

													<label htmlFor="no_years">Select number of days to run the car</label>

													<select id="drop" placeholder="" name="dropoption" className="form-control custom-select browser-default textbox"
														onChange={handleDays}>
														<option style={{ "display": "none" }}>{!selectDays ? "-- Select --" : selectDays}</option>
														<option value="4">4</option>
														<option value="5">5</option>
														<option value="6">6</option>
														<option value="7">7</option>
														{/* <option value="5">5</option>  */}
													</select>
													{/* } */}
												</div>

												<div className="editDays">
													{/* <label class="control-label" for="dealername">Bids</label> */}
													<select id="dropBids" placeholder="" name="dropBids" className="form-control custom-select browser-default textbox" value={selectedBid}
														// onChange={(e) => { setSelectedBid(e.target.value); setBidFlag(true) }}
														onChange={handleBidtype}>
														{!bidType ?
															<option style={{ "display": "none" }}>-- Select Bids --</option> :
															<option style={{ "display": "none" }}>{bidType}</option>}
														<option value="3">Auction</option>
														<option value="2" >Make Bid</option>
														<option value="1">Sealed Bids</option>
													</select>
													{/* <p className="form-input-error1" >{SalesIdError}</p> */}
												</div>

												<div class="editMessage">
													{/* {carDetail[0].announcement == "" || carDetail[0].announcement == undefined || carDetail[0].announcement == null ? "" :
													<p><span class="dealertaglines">Announcement : </span> {carDetail[0].announcement}</p>} */}
													{carDetail[0].announcement == "null" || carDetail[0].announcement == null || carDetail[0].announcement == "undefined" || carDetail[0].announcement == undefined ?
														<p><span className="label">Announcement : </span>{""}</p> :
														<p><span className="label">Announcement :  {carDetail[0].announcement}</span></p>}
													{carDetail[0].dealer_message == "" || carDetail[0].dealer_message == undefined || carDetail[0].dealer_message == "undefined" || carDetail[0].dealer_message == null || carDetail[0].dealer_message == "null" ? <p><span class="dealertaglines">Message From The Dealer : </span>No Message</p> :
														<p><span class="dealertaglines">Message From The Dealer : {carDetail[0].dealer_message}</span></p>}
													<label for="address">Message From The Dealer</label>
													<input className="textbox mb-3" type="text" placeholder="" id="address" name="address"
														onChange={handleMessage} />

													<p className="form-input-error" >{messageError}</p>
												</div>

											</div>

											<div class="cars-detail-ins">

												{carDetail[0].sales_type_id == 1 ? "" :
													<>
														{carDetail[0].min_price == "" || carDetail[0].min_price == undefined || carDetail[0].min_price == null || carDetail[0].min_price == 0 ? "" :
															<a class="car-btns" >Minimum Bid : <span class="green"> $ {carDetail[0].min_price}</span></a>}
													</>}
												{carDetail[0].max_price == "" || carDetail[0].max_price == undefined || carDetail[0].max_price == null || carDetail[0].max_price == 0 ? "" :
													<a class="car-btns" >Sell it Now : <span class="red"> $ {carDetail[0].max_price}</span></a>}

												{carDetail[0].high_bid == "" || carDetail[0].high_bid == undefined || carDetail[0].high_bid == null ? "" :
													<a class="car-btns" >High Bid : <span class="green"> $ {carDetail[0].high_bid}</span></a>
												}


												
											</div>

											<div className='proxybid-sec'>
												{proxyBidList.length > 0 ? proxyBidList.map((item) =>
													<>
														{item.display == "yes" ? <>
															{item.proxy_bid == "" || item.proxy_bid == undefined || item.proxy_bid == null ? "" :
																<a class="car-btns" >Proxy Bid From Buyer : <span class="red">{item.proxy_bid} $ </span></a>
															}
														</> : ""}
													</>) : ""}
											</div>

											<div className='sell-it-now'>
												<label for="address">Sell it Now </label>
												<input className="textbox " type="text" placeholder="" id="address" name="address" value={sellAmount}
													onChange={handlePrice} />
													<p className="form-input-error" >{sellItError}</p>
											</div>


											<div class="custom-button-accept">
												<div class="cars-buy">
													<a class="cars-buy-btns greenBtn butnpad-apb" onClick={() => handleSave(carDetail[0].high_bid, carDetail[0].min_price, carDetail[0].max_price, carDetail[0].days, carDetail[0].dealer_message)}>Update</a>
													<a class="cars-buy-btns-primary greyBtn" onClick={() => { redirectpage(carDetail[0].car_id, carDetail[0]) }} >Cancel</a>
												</div>
											</div>


										</div>


									</div>}
							</div>
						</div>}
				</div>}


			<section id="playstoreBlock" class="playstoreBlock">
				<div class="container">


					<div class="row content">
						<div class="col-lg-12">
							<img src={appstore} />
							<img src={googleplay} />

						</div>

					</div>

				</div>
			</section>

		</main>
	)
}
export default EditDetails;